document.addEventListener('DOMContentLoaded', () => {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    // 1. Main Content: Target top-level sections
    // This keeps the nice full-section fade for the main page
    const mainContent = document.getElementById('MainContent');
    if (mainContent) {
        // Exclude .wholesale-contact-section to prevent breaking position:fixed children (the floating button)
        const sections = mainContent.querySelectorAll('.shopify-section:not(.wholesale-contact-section)');
        sections.forEach(section => {
            section.classList.add('animate-on-scroll');
            observer.observe(section);
        });
    }

    // 2. Footer Group: Target INTERNAL blocks only
    // This avoids the "juggling" effect of animating the whole container
    const footerGroup = document.getElementById('footer-group');
    if (footerGroup) {
        // Target common inner elements like blocks, grid items, or the content wrappers
        // Adjust these selectors based on standard Dawn/Shopify theme structure
        const footerTargets = footerGroup.querySelectorAll('.footer-block, .footer__content-top, .footer__content-bottom, .list-social__item, .newsletter-form__field-wrapper');

        footerTargets.forEach(el => {
            el.classList.add('animate-on-scroll');
            observer.observe(el);
        });
    }
});
